import React from 'react'
import styles from 'css/components/connection-banner.module.css'

interface ConnectionBannerProps {
    reconnectAttempt?: number
    maxAttempts?: number
}

export const ConnectionBanner: React.FC<ConnectionBannerProps> = ({ reconnectAttempt, maxAttempts }) => {
    if (!reconnectAttempt || !maxAttempts) return null

    return (
        <div className={styles.banner}>
            <span className={styles.text}>
                🔄 Connection Lost - Reconnecting... (Attempt {reconnectAttempt} of {maxAttempts})
            </span>
        </div>
    )
}
